import React from 'react'
import { StyledButton } from '../ProductProtection.css'
import useUpdateProtectionPlan from '../hooks/updateProtectionPlan'

const Plan = ({
  product,
  plan,
  quantity,
  isOptionSelected,
  setShowOptionLoader,
}) => {
  const handleOptionClick = useUpdateProtectionPlan({
    product,
    plan,
    quantity,
    isOptionSelected: !isOptionSelected,
    setShowOptionLoader,
  })

  const buttonClasses = []
  if (isOptionSelected) {
    buttonClasses.push('product-protection-plan-selected')
  }

  const price = (quantity * parseFloat(plan?.price)).toFixed(2)

  return (
    <StyledButton
      key={`product:${product?.productId}|code:${plan.code}`}
      type="button"
      id={`select-plan-cta|product:${product?.productId}|code:${plan.code}`}
      onClick={handleOptionClick}
      className={buttonClasses.join(' ')}
      value={plan.code}
    >
      <span>
        {plan.type}
        {' - $'}
        {price}
      </span>
    </StyledButton>
  )
}

export default Plan
